import MUIDataTable, {
  debounceSearchRender,
  MUIDataTableOptions,
  MUIDataTableProps,
  MUIDataTableState,
} from 'mui-datatables';
import React, { memo } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

import { IAppState } from 'src/store';
import View from '../View';
import './styles.scss';

const TableBasic: React.FC<Props> = ({
  isLoading,
  containerClassName,
  onTableChange,
  currentPage,
  options,
  total,
  ...props
}) => {
  const tableOptions: MUIDataTableOptions = {
    serverSide: true,
    searchOpen: false,
    search: true,
    download: false,
    filter: true,
    print: false,
    viewColumns: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: isLoading ? 'Loading...' : 'No data',
      },
    },
    jumpToPage: true,
    rowHover: true,
    onTableChange,
    customSearchRender: debounceSearchRender(500),
    ...options,
  };

  const hasRowClickAction = !!options?.onRowClick;
  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiPaper: {
          elevation4: {
            boxShadow: 'none',
          },
        },
        MuiTableRow: {
          hover: {
            cursor: hasRowClickAction ? 'pointer' : 'default',
          },
        },
        MuiTableBody: {
          root: {
            opacity: isLoading ? 0.3 : 1,
          },
        },
        MuiPopover: {
          paper: {
            minWidth: 300,
          },
        },
      },
    });

  // More info: https://github.com/gregnb/mui-datatables
  return (
    <View className={cn('cmp-table-basic', containerClassName)}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable options={tableOptions} {...props} />
      </MuiThemeProvider>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  MUIDataTableProps & {
    containerClassName?: string;
    currentPage?: number;
    total?: number;
    onTableChange: (action: string, tableState: MUIDataTableState) => void;
  };

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(memo(TableBasic));
